import { render, staticRenderFns } from "./addConstituencyPresident.vue?vue&type=template&id=25a94636&scoped=true&"
import script from "./addConstituencyPresident.vue?vue&type=script&lang=js&"
export * from "./addConstituencyPresident.vue?vue&type=script&lang=js&"
import style0 from "./addConstituencyPresident.vue?vue&type=style&index=0&id=25a94636&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a94636",
  null
  
)

export default component.exports